<template>
  <v-menu offset-y>
    <template #activator="{ on, attrs }">
      <v-btn
        color="grey"
        small
        icon
        v-bind="attrs"
        v-on="on"
      >
        <v-icon>mdi-chevron-down</v-icon>
      </v-btn>
    </template>
    <v-list class="text-right">
      <v-list-item @click.stop="showModal=true">
        <v-list-item-title class="d-flex align-center justify-space-between">
          <v-icon left>
            mdi-translate
          </v-icon>
          {{ currentLanguage }}
        </v-list-item-title>
      </v-list-item>
      <v-list-item @click="goToHelpCenter">
        <v-list-item-title class="d-flex align-center justify-space-between">
          <v-icon left>
            mdi-help-circle-outline
          </v-icon>
          {{ $t("user-menu.help", "Help Center") }}
        </v-list-item-title>
      </v-list-item>
      <v-list-item @click.prevent="logout()">
        <v-list-item-title class="d-flex align-center justify-space-between">
          <v-icon left />
          {{ $t("user-menu.logout", "Logout") }}
        </v-list-item-title>
      </v-list-item>
    </v-list>
    <language-selector
      :show="showModal"
      @close="showModal=false"
    />
  </v-menu>
</template>

<script>
  import Cookies from 'js-cookie';
  import { languages } from '~/static/languages.json';
  import LanguageSelector from '~/components/common/LanguageSelector.vue';
  import supportLink from '~/components/mixins/supportLink';

  export default {
    name: 'UserMenu',
    components: {
      LanguageSelector,
    },
    mixins: [
      supportLink,
    ],
    data() {
      return {
        showModal: false,
      };
    },
    computed: {
      currentLanguage() {
        const userLocale = this.$auth.user?.attributes?.locale?.replace('_', '-');
        if (userLocale !== Cookies.get('locale') || userLocale !== this.$i18n.i18next.language) {
          Cookies.set('locale', userLocale);
          this.$i18n.i18next.changeLanguage(userLocale);
        }
        const userLanguage = languages.find(
          (language) => language.lang_iso === userLocale,
        );
        return userLanguage?.translation;
      },
    },
    methods: {
      logout() {
        this.$auth.logout();
      },
    },
  };
</script>

<style>

</style>
